import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import styles from './AdvancedFilters.module.scss';

export default function DatePicker({
  selected, changeField, filterName, bindSelectRef, placeholderText, className, readOnly
}) {
  function formatDate(date) {
    return date ? date.format('YYYY-MM-DD') : '';
  }

  return (
    <label className={styles.datePickWrapper} htmlFor="select-due-date">
      <ReactDatePicker
        ref={(ref) => { bindSelectRef(ref); }}
        className={className}
        dateFormat="MM/dd/yyyy"
        id="select-due-date"
        placeholderText={placeholderText}
        readOnly={readOnly}
        selected={selected ? new Date(`${selected}T00:00:00`) : null}
        title="Date Select"
        onChange={date => changeField(filterName, { value: formatDate(moment(date)) })}
      />
      <img alt="" className={styles.calendarIcon} src="/images/icon_calendar_small.png" />
    </label>
  );
}

DatePicker.propTypes = {
  bindSelectRef: PropTypes.func,
  changeField: PropTypes.func.isRequired,
  className: PropTypes.string,
  filterName: PropTypes.string.isRequired,
  placeholderText: PropTypes.string,
  readOnly: PropTypes.bool,
  selected: PropTypes.string
};

DatePicker.defaultProps = {
  bindSelectRef: () => {},
  className: '',
  placeholderText: null,
  readOnly: false,
  selected: null
};
